 export enum EtatAbsencesEnum {
EnAttenteValidationGestionnaire = 0,
EnAttenteValidationResponsableNiveau_1 = 1,
EnAttenteValidationResponsableNiveau_2 = 2,
Valide = 4,
Calcule = 5,
Cloture = 6,
Annule = 7,
Refuse = 8,
EnAttenteAnnulationGestionnaire = 9,
EnAttenteAnnulationResponsableNiveau_1 = 10,
EnAttenteAnnulationResponsableNiveau_2 = 11,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum.ts